<template>
  <div>
    <v-dialog width="1200" v-model="searchOpen" @click:outside="$emit('close-search');" persistent>
      <SearchBox />
    </v-dialog>
  </div>
</template>

<script>
  import SearchBox from "./SearchBox";

  export default {
    components: { SearchBox },

    props: {
      searchOpen: {
        type: Boolean,
        default: false
      },
    },

    data() {
      return {}
    },

    computed: {},
    watch: {},
    filters: {},
    methods: {},
  }
</script>

<style lang="scss" scoped></style>
